import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import clsx from 'clsx';
import { useTheme, keyframes } from '@emotion/react';
import { rgba } from 'polished';
import { jsx as ___EmotionJSX } from "@emotion/react";
const skeletonKeyframes = keyframes({
  from: {
    backgroundPosition: '100% 0'
  },
  to: {
    backgroundPosition: '-100% 0'
  }
});

const Skeleton = _ref => {
  let {
    as: Component = 'div',
    className
  } = _ref,
      rest = _objectWithoutProperties(_ref, ["as", "className"]);

  const theme = useTheme();
  return ___EmotionJSX(Component, _extends({
    css: [{
      animation: skeletonKeyframes + " 1.25s linear infinite",
      animationFillMode: 'forwards',
      backgroundImage: "linear-gradient(to right, " + theme.color.panel.dark + " 0%, " + rgba(theme.color.panel.dark, 0.5) + " 50%, " + theme.color.panel.dark + " 100%)",
      backgroundSize: '200% 100%'
    }, theme.settings.contrast.enable && {
      '.u-contrast &': {
        backgroundImage: "linear-gradient(to right, " + rgba(theme.contrast.base, 0.5) + " 0%, " + rgba(theme.contrast.base, 0.35) + " 50%, " + rgba(theme.contrast.base, 0.5) + " 100%)"
      }
    }, process.env.NODE_ENV === "production" ? "" : ";label:Skeleton;"],
    className: clsx('CK__Skeleton', className)
  }, rest));
};

export default Skeleton;